var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21428_88802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.62803 14.6521H17.036C17.7518 14.6521 18.332 14.0719 18.332 13.3561V4.64414C18.332 3.92839 17.7518 3.34814 17.036 3.34814H1.62803C0.912279 3.34814 0.332031 3.92839 0.332031 4.64414V13.3561C0.332031 14.0719 0.912279 14.6521 1.62803 14.6521Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74218 7.20215V10.7893H5.54472L4.64792 7.83517H4.59518V10.7893H3.86719V7.20215H5.09634L5.96145 10.1563H6.01419V7.20215H6.74218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25143 7.83517V8.67394H9.52803V9.29641H8.25143V10.1563H9.84457V10.7893H7.52344V7.20215H9.84457V7.83517H8.25143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1562 7.20215H10.9211L11.3643 10.1668H11.4434L12.087 7.20215H12.931L13.5746 10.1668H13.6537L14.0968 7.20215H14.8617L14.1759 10.7893H13.0734L12.509 8.06201L11.9445 10.7893H10.842L10.1562 7.20215Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21428_88802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.332031)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIcon);
export default __webpack_public_path__ + "static/media/new_icon.6a8eff4a1ca0a6e8c41bc6fc3759d11d.svg";
export { ForwardRef as ReactComponent };